var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWordIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "52px",
    viewBox: "0 0 42 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_file_word") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-65.3944642%",
    y1: "163.114761%",
    x2: "87.4089651%",
    y2: "13.1088228%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57B7E5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C81C6",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "File_Type_Solid",
    transform: "translate(-12.000000, -84.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_file_word",
    transform: "translate(12.000000, 84.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,0 L27.937,0 L42,14.063 L42,48 C42,50.209 40.209,52 38,52 L4,52 C1.791,52 0,50.209 0,48 L0,4 C0,1.791 1.791,0 4,0",
    id: "Page-1",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    fill: "#66A8DD",
    points: "28 0 42 14 28 14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1056881,27.6321785 L17.3417163,40.4732529 C17.3104972,40.5797589 17.2127974,40.6529317 17.1018102,40.6529317 L14.9838196,40.6529317 C14.8683778,40.6529317 14.7679475,40.573888 14.7408201,40.4616788 L10.4806333,22.8399971 C10.4426023,22.6826873 10.5617911,22.53125 10.7236328,22.53125 L13.0473711,22.53125 C13.1637919,22.53125 13.2648029,22.6116116 13.290973,22.725053 L16.0746177,34.7915479 L16.2284808,35.8408001 L16.4255859,35.0095183 L19.9111932,22.7130701 C19.9416868,22.6054956 20.0399036,22.53125 20.1517166,22.53125 L22.1123708,22.53125 C22.2247764,22.53125 22.3233612,22.6062698 22.3533248,22.7146082 L25.7570417,35.0222929 L25.9535046,35.8867297 L26.1287551,34.7803215 L28.8639886,22.7259294 C28.889825,22.6120666 28.9910339,22.53125 29.1077911,22.53125 L31.4436321,22.53125 C31.6055406,22.53125 31.7247422,22.6828047 31.6865935,22.8401548 L27.4143039,40.4618364 C27.3871179,40.5739692 27.2867238,40.6529317 27.1713425,40.6529317 L25.053352,40.6529317 C24.9414778,40.6529317 24.8432229,40.5786064 24.8127836,40.4709529 L21.177711,27.6125816 L21.1437859,27.4488562 L21.1056881,27.6321785 Z",
    id: "W",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordIcon);
export default __webpack_public_path__ + "static/media/wordIcon.d7db8ecee5824ba530a5b74c5dd69110.svg";
export { ForwardRef as ReactComponent };